import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  align-items: center;
  width:100%;
  max-width:100%;
  height:100%;
  gap: 0.5rem;
`
export const Icon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  color: #999;
`
export const Message = styled.div`
  display: flex;
  max-width:100%;
  height:100%;

  p{
    color: #999;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

`